
import TestController from '@/controllers/TestController';
import { inject } from 'vue';
import { Prop, Vue } from 'vue-property-decorator';
export default class PauseView extends Vue {
  @Prop({ default: 'Paused' }) title: string | undefined;
  @Prop({ default: 'Test is paused' }) message: string | undefined;
  @Prop({ default: false }) showReviewButton: boolean | undefined;
  @Prop({ default: false }) waitForProctorToContinue: boolean | undefined;
  private testController: TestController | undefined = inject<TestController>('testController');

  private get displayResumeButton() {
    return this.showReviewButton || this.testController!.sessionController === null;
  }

  private resumeClicked() {
    this.testController?.pauseManager?.unpauseTest();
  }

  private additionalMessage(): string {
    if (this.waitForProctorToContinue && this.testController && !this.testController.sessionController) {
      return '(' + this.$t('status.wait_admin') + ')';
    }
    return '';
  }
}
